import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../ui/Button';
import { Check, Gift, ShieldCheck, Sparkles, ShoppingCart, ChevronLeft, ChevronRight, Star } from 'lucide-react';
export function PricingSection() {
  const [bonusSlide, setBonusSlide] = useState(0);
  const [isBonusAutoPlaying, setIsBonusAutoPlaying] = useState(true);
  const bonusEbooks = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/tMNCvDUjopymAWvPLfRyaC/bono_1_cover_1.png',
    title: 'Caja Express Anti-Pantallas',
    subtitle: '30 actividades sin preparar (sin imprimir)',
    badge: 'BONO 1',
    value: '$50'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/r1DavEwr5FUbtB3gYEU2gC/bono_2_cover_1.png',
    title: 'Kit de Bolsillo sin Pantallas',
    subtitle: 'Para salidas, viajes y esperas',
    badge: 'BONO 2',
    value: '$50'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/mXqBDsmFWQwimNd5afVLqe/bono_3_cover1.png',
    title: 'Guía Visual Antipantallas',
    subtitle: 'Rutinas visuales reduce el uso de pantallas',
    badge: 'BONO 3',
    value: '$50'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/tD7a3qwK6Dn5Q7EB9QQMEp/bono_4_cover_1.png',
    title: 'Calma sin las pantallas',
    subtitle: 'Kit de pasos exactos para cuando tu niño pide ver el móvil',
    badge: 'BONO 4',
    value: '$50'
  }, {
    id: 5,
    image: 'https://cdn.magicpatterns.com/uploads/nXHXxZrBRpiZUUX3vyrpo3/bono_5_cover_1.png',
    title: 'Desconexión Inteligente',
    subtitle: 'Recupera la infancia de tu hijo',
    badge: 'BONO 5',
    value: '$50'
  }, {
    id: 6,
    image: 'https://cdn.magicpatterns.com/uploads/fVvu7NiMJznHPiagKg7JwU/bono_6_cover_1.png',
    title: 'Pantallas Bajo Control',
    subtitle: 'Cómo quitar la pantalla con amor y firmeza',
    badge: 'BONO 6',
    value: '$50'
  }];
  // Auto-advance bonus carousel
  useEffect(() => {
    if (!isBonusAutoPlaying) return;
    const interval = setInterval(() => {
      setBonusSlide(prev => (prev + 1) % bonusEbooks.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [isBonusAutoPlaying, bonusEbooks.length]);
  const nextBonusSlide = () => {
    setIsBonusAutoPlaying(false);
    setBonusSlide(prev => (prev + 1) % bonusEbooks.length);
  };
  const prevBonusSlide = () => {
    setIsBonusAutoPlaying(false);
    setBonusSlide(prev => (prev - 1 + bonusEbooks.length) % bonusEbooks.length);
  };
  const goToBonusSlide = (index: number) => {
    setIsBonusAutoPlaying(false);
    setBonusSlide(index);
  };
  return <section id="pricing" className="py-16 bg-gradient-to-b from-brand-navy to-[#1a2744] text-white relative overflow-hidden" data-id="element-459">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-460">
        <div className="absolute top-10 right-10 w-96 h-96 bg-brand-yellow/10 rounded-full blur-3xl" data-id="element-461"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-brand-red/10 rounded-full blur-3xl" data-id="element-462"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-463">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12" data-id="element-464">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block bg-brand-red px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-bold mb-3 sm:mb-4 shadow-lg" data-id="element-465">
            🎁 OFERTA DE LANZAMIENTO
          </motion.div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 font-serif px-4" data-id="element-466">
            Pack Anti-Pantallas Premium
          </h2>
          <p className="text-brand-cream/80 text-base sm:text-lg mb-6 sm:mb-8 px-4" data-id="element-467">
            7 Ebooks Digitales • Sistema Completo
          </p>
        </div>

        {/* COLLAGE IMAGE SHOWCASE - STATIC */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-468">
          <div className="max-w-5xl mx-auto" data-id="element-469">
            {/* Luxury frame with golden border */}
            <div className="relative" data-id="element-470">
              {/* Golden glow effect */}
              <div className="absolute -inset-6 bg-gradient-to-r from-[#FFD700]/30 via-[#FF6B6B]/20 via-[#4ECDC4]/20 to-[#FFD700]/30 rounded-3xl blur-2xl opacity-75 animate-pulse" data-id="element-471" />

              {/* Main container */}
              <div className="relative bg-gradient-to-br from-[#5a6678] to-[#4a5568] rounded-2xl p-8 border-4 border-brand-yellow/40 shadow-2xl overflow-hidden" data-id="element-472">
                {/* Content */}
                <div className="flex flex-col items-center text-center" data-id="element-473">
                  {/* Badge */}
                  <div className="inline-block bg-brand-red text-white px-5 py-2 rounded-full text-sm font-bold mb-6 shadow-lg" data-id="element-474">
                    PACK COMPLETO
                  </div>

                  {/* Title */}
                  <h3 className="text-3xl md:text-4xl font-bold mb-3 font-serif text-white" data-id="element-475">
                    7 Ebooks Digitales Premium
                  </h3>

                  {/* Subtitle */}
                  <p className="text-brand-cream/80 mb-8 text-lg max-w-2xl" data-id="element-476">
                    Sistema completo para transformar las tardes sin pantallas.
                    Todo lo que necesitas en un solo pack.
                  </p>

                  {/* Collage Image */}
                  <div className="relative w-full max-w-4xl mb-8" data-id="element-477">
                    <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white/20" data-id="element-478">
                      <img src="https://cdn.magicpatterns.com/uploads/vdFtiWS9Lg15672pcB3Xfw/Collage_de_Fotos_anti-pantalla.png" alt="Pack completo de 7 ebooks anti-pantallas" className="w-full h-auto" data-id="element-479" />

                      {/* Shine overlay effect */}
                      <div className="absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-transparent opacity-50" data-id="element-480" />
                    </div>

                    {/* Floating value badge */}
                    <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 px-6 py-3 bg-gradient-to-r from-brand-yellow to-[#FFA500] text-brand-navy rounded-full shadow-xl font-bold text-lg border-4 border-white/20" data-id="element-481">
                      Valor Total: $347.00
                    </div>
                  </div>

                  {/* Features grid */}
                  <div className="grid md:grid-cols-3 gap-4 w-full max-w-3xl mt-8" data-id="element-482">
                    <div className="flex items-center gap-3 bg-white/10 px-4 py-3 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-483">
                      <div className="flex-shrink-0 w-10 h-10 bg-brand-yellow/20 rounded-full flex items-center justify-center" data-id="element-484">
                        <Check className="w-5 h-5 text-brand-yellow" strokeWidth={3} data-id="element-485" />
                      </div>
                      <div className="text-left" data-id="element-486">
                        <p className="font-bold text-white text-sm" data-id="element-487">
                          1 Ebook Principal
                        </p>
                        <p className="text-xs text-brand-cream/70" data-id="element-488">
                          Sistema completo
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 bg-white/10 px-4 py-3 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-489">
                      <div className="flex-shrink-0 w-10 h-10 bg-brand-green/20 rounded-full flex items-center justify-center" data-id="element-490">
                        <Gift className="w-5 h-5 text-brand-green" data-id="element-491" />
                      </div>
                      <div className="text-left" data-id="element-492">
                        <p className="font-bold text-white text-sm" data-id="element-493">
                          6 Bonos Gratis
                        </p>
                        <p className="text-xs text-brand-cream/70" data-id="element-494">
                          Valor $300
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 bg-white/10 px-4 py-3 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-495">
                      <div className="flex-shrink-0 w-10 h-10 bg-brand-red/20 rounded-full flex items-center justify-center" data-id="element-496">
                        <Star className="w-5 h-5 text-brand-red fill-brand-red" data-id="element-497" />
                      </div>
                      <div className="text-left" data-id="element-498">
                        <p className="font-bold text-white text-sm" data-id="element-499">
                          Acceso Inmediato
                        </p>
                        <p className="text-xs text-brand-cream/70" data-id="element-500">
                          Descarga ahora
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Value proposition */}
                  <div className="mt-8 bg-white/5 backdrop-blur-sm border border-white/20 rounded-xl p-6 max-w-2xl" data-id="element-501">
                    <p className="text-brand-cream/90 leading-relaxed" data-id="element-502">
                      <span className="font-bold text-white" data-id="element-503">
                        Todo incluido:
                      </span>{' '}
                      Rutinas diarias, actividades listas, guías visuales,
                      protocolos de emergencia, estrategias para salidas y
                      viajes. Un sistema completo probado por más de 500
                      familias.
                    </p>
                  </div>
                </div>

                {/* Decorative corner accents */}
                <div className="absolute top-0 left-0 w-20 h-20 border-t-2 border-l-2 border-[#FFD700]/50 rounded-tl-2xl" data-id="element-504" />
                <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-[#FFD700]/50 rounded-tr-2xl" data-id="element-505" />
                <div className="absolute bottom-0 left-0 w-20 h-20 border-b-2 border-l-2 border-[#FFD700]/50 rounded-bl-2xl" data-id="element-506" />
                <div className="absolute bottom-0 right-0 w-20 h-20 border-b-2 border-r-2 border-[#FFD700]/50 rounded-br-2xl" data-id="element-507" />
              </div>

              {/* Floating particles effect */}
              <div className="absolute -top-3 left-1/4 w-3 h-3 bg-[#FFD700] rounded-full animate-ping opacity-75" data-id="element-508" />
              <div className="absolute -bottom-3 right-1/4 w-3 h-3 bg-[#FFA500] rounded-full animate-ping opacity-75" style={{
              animationDelay: '1s'
            }} data-id="element-509" />
              <div className="absolute top-1/2 -left-3 w-2 h-2 bg-[#4ECDC4] rounded-full animate-ping opacity-75" style={{
              animationDelay: '0.5s'
            }} data-id="element-510" />
              <div className="absolute top-1/2 -right-3 w-2 h-2 bg-[#FF6B6B] rounded-full animate-ping opacity-75" style={{
              animationDelay: '1.5s'
            }} data-id="element-511" />
            </div>
          </div>
        </motion.div>

        {/* BONUSES SECTION - CAROUSEL ON MOBILE, GRID ON DESKTOP */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-512">
          <div className="max-w-5xl mx-auto" data-id="element-513">
            {/* Header */}
            <div className="text-center mb-6" data-id="element-514">
              <div className="inline-flex items-center gap-2 bg-brand-green text-white px-5 py-2 rounded-full font-bold text-sm mb-2 shadow-lg" data-id="element-515">
                <Gift className="w-4 h-4" data-id="element-516" />
                <span data-id="element-517">6 EBOOKS DE REGALO</span>
              </div>
              <p className="text-brand-cream/70 text-sm" data-id="element-518">
                Cada situación cubierta: casa, salidas, emergencias
              </p>
            </div>

            {/* MOBILE: Premium Carousel (visible only on mobile) */}
            <div className="md:hidden" onMouseEnter={() => setIsBonusAutoPlaying(false)} onMouseLeave={() => setIsBonusAutoPlaying(true)} data-id="element-519">
              <div className="relative" data-id="element-520">
                {/* Golden glow effect */}
                <div className="absolute -inset-4 bg-gradient-to-r from-[#FFD700]/20 via-[#4ECDC4]/10 to-[#FFD700]/20 rounded-3xl blur-2xl opacity-75 animate-pulse" data-id="element-521" />

                {/* Main carousel frame */}
                <div className="relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-2xl p-6 border-2 border-brand-green/30 shadow-2xl overflow-hidden" data-id="element-522">
                  {/* Carousel content */}
                  <AnimatePresence mode="wait" data-id="element-523">
                    <motion.div key={bonusSlide} initial={{
                    opacity: 0,
                    scale: 0.9,
                    rotateY: -20
                  }} animate={{
                    opacity: 1,
                    scale: 1,
                    rotateY: 0
                  }} exit={{
                    opacity: 0,
                    scale: 0.9,
                    rotateY: 20
                  }} transition={{
                    duration: 0.6,
                    ease: 'easeInOut'
                  }} className="flex flex-col items-center gap-6" data-id="element-524">
                      {/* Ebook image with 3D effect */}
                      <div className="relative flex-shrink-0" data-id="element-525">
                        <div className="relative w-48 h-64 transform perspective-1000" data-id="element-526">
                          {/* 3D shadow layers */}
                          <div className="absolute inset-0 bg-gradient-to-br from-black/40 to-black/20 rounded-lg transform translate-x-2 translate-y-2 blur-md" data-id="element-527" />
                          <div className="absolute inset-0 bg-gradient-to-br from-black/30 to-black/10 rounded-lg transform translate-x-1 translate-y-1 blur-sm" data-id="element-528" />

                          {/* Main image */}
                          <div className="relative w-full h-full rounded-lg overflow-hidden shadow-2xl border-4 border-white/20" data-id="element-529">
                            <img src={bonusEbooks[bonusSlide].image} alt={bonusEbooks[bonusSlide].title} className="w-full h-full object-cover" data-id="element-530" />

                            {/* Shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent opacity-50" data-id="element-531" />
                          </div>

                          {/* Floating badge */}
                          <div className="absolute -top-3 -right-3 px-3 py-1 bg-gradient-to-r from-brand-green to-[#44A08D] rounded-full shadow-lg transform rotate-12" data-id="element-532">
                            <span className="text-white font-bold text-xs drop-shadow-lg" data-id="element-533">
                              {bonusEbooks[bonusSlide].badge}
                            </span>
                          </div>

                          {/* Value badge */}
                          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-brand-yellow text-brand-navy rounded-full shadow-lg font-bold text-sm" data-id="element-534">
                            Valor: {bonusEbooks[bonusSlide].value}
                          </div>
                        </div>
                      </div>

                      {/* Ebook info */}
                      <div className="text-center" data-id="element-535">
                        <motion.div initial={{
                        opacity: 0,
                        y: 20
                      }} animate={{
                        opacity: 1,
                        y: 0
                      }} transition={{
                        delay: 0.2
                      }} data-id="element-536">
                          <h3 className="text-2xl font-bold text-white mb-3 font-serif" data-id="element-537">
                            {bonusEbooks[bonusSlide].title}
                          </h3>
                          <p className="text-brand-cream/80 mb-6 text-base" data-id="element-538">
                            {bonusEbooks[bonusSlide].subtitle}
                          </p>

                          {/* Value indicator */}
                          <div className="inline-flex items-center gap-2 bg-brand-green/20 px-4 py-2 rounded-full border border-brand-green/40 backdrop-blur-sm" data-id="element-539">
                            <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-540" />
                            <span className="text-sm font-semibold text-white" data-id="element-541">
                              ¡GRATIS con tu Pack Premium!
                            </span>
                          </div>
                        </motion.div>
                      </div>
                    </motion.div>
                  </AnimatePresence>

                  {/* Navigation arrows */}
                  <button onClick={prevBonusSlide} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-gradient-to-br from-brand-green to-[#44A08D] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 group z-10 border-2 border-white/20" aria-label="Bono anterior" data-id="element-542">
                    <ChevronLeft className="w-5 h-5 text-white group-hover:-translate-x-0.5 transition-transform" strokeWidth={3} data-id="element-543" />
                  </button>

                  <button onClick={nextBonusSlide} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-gradient-to-br from-brand-green to-[#44A08D] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 group z-10 border-2 border-white/20" aria-label="Siguiente bono" data-id="element-544">
                    <ChevronRight className="w-5 h-5 text-white group-hover:translate-x-0.5 transition-transform" strokeWidth={3} data-id="element-545" />
                  </button>

                  {/* Slide counter */}
                  <div className="absolute top-4 right-4 bg-brand-green/80 backdrop-blur-sm px-3 py-1 rounded-full border border-white/30 z-10" data-id="element-546">
                    <span className="text-white text-xs font-bold" data-id="element-547">
                      Bono {bonusSlide + 1} / {bonusEbooks.length}
                    </span>
                  </div>

                  {/* Progress indicators */}
                  <div className="flex items-center justify-center gap-2 mt-6" data-id="element-548">
                    {bonusEbooks.map((_, index) => <button key={index} onClick={() => goToBonusSlide(index)} className="group relative" aria-label={`Ir a bono ${index + 1}`} data-id="element-549">
                        <div className={`relative h-1.5 rounded-full transition-all duration-500 ${index === bonusSlide ? 'w-12 bg-gradient-to-r from-brand-green to-[#44A08D]' : 'w-1.5 bg-white/30 group-hover:bg-white/50'}`} data-id="element-550">
                          {index === bonusSlide && <motion.div layoutId="activeBonusIndicator" className="absolute inset-0 bg-gradient-to-r from-brand-green to-[#44A08D] rounded-full" style={{
                        boxShadow: '0 0 10px rgba(85, 139, 47, 0.6)'
                      }} data-id="element-551" />}
                        </div>
                      </button>)}
                  </div>

                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-brand-green/50 rounded-tl-2xl" data-id="element-552" />
                  <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-brand-green/50 rounded-tr-2xl" data-id="element-553" />
                  <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-brand-green/50 rounded-bl-2xl" data-id="element-554" />
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-brand-green/50 rounded-br-2xl" data-id="element-555" />
                </div>

                {/* Floating particles effect */}
                <div className="absolute -top-2 left-1/4 w-2 h-2 bg-brand-green rounded-full animate-ping opacity-75" data-id="element-556" />
                <div className="absolute -bottom-2 right-1/4 w-2 h-2 bg-brand-yellow rounded-full animate-ping opacity-75" style={{
                animationDelay: '1s'
              }} data-id="element-557" />
              </div>
            </div>

            {/* DESKTOP: Static Grid (visible only on desktop) */}
            <div className="hidden md:block" data-id="element-558">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-brand-green/30" data-id="element-559">
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-560">
                  {bonusEbooks.map((bonus, i) => <motion.div key={i} initial={{
                  opacity: 0,
                  scale: 0.9
                }} whileInView={{
                  opacity: 1,
                  scale: 1
                }} viewport={{
                  once: true
                }} transition={{
                  delay: i * 0.05
                }} className="bg-brand-offwhite rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow" data-id="element-561">
                      <div className="relative" data-id="element-562">
                        <img src={bonus.image} alt={bonus.title} className="w-full aspect-[3/4] object-cover" data-id="element-563" />
                        <div className="absolute top-2 left-2 px-3 py-1 bg-brand-green text-white rounded-full text-xs font-bold shadow-lg" data-id="element-564">
                          {bonus.badge}
                        </div>
                        <div className="absolute bottom-2 right-2 px-2 py-1 bg-brand-yellow text-brand-navy rounded-full text-xs font-bold shadow-lg" data-id="element-565">
                          {bonus.value}
                        </div>
                      </div>
                      <div className="p-3" data-id="element-566">
                        <h4 className="font-bold text-brand-navy text-sm leading-tight mb-1" data-id="element-567">
                          {bonus.title}
                        </h4>
                        <p className="text-xs text-slate-600 leading-tight" data-id="element-568">
                          {bonus.subtitle}
                        </p>
                      </div>
                    </motion.div>)}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-4 text-xs text-brand-cream/70 mb-8" data-id="element-569">
          <div className="flex items-center gap-2" data-id="element-570">
            <Check className="w-3 h-3 text-brand-yellow" data-id="element-571" />
            <span data-id="element-572">7 ebooks digitales PDF</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-573">
            <Check className="w-3 h-3 text-brand-yellow" data-id="element-574" />
            <span data-id="element-575">Descarga instantánea</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-576">
            <Check className="w-3 h-3 text-brand-yellow" data-id="element-577" />
            <span data-id="element-578">Acceso de por vida</span>
          </div>
        </motion.div>

        {/* PAYMENT SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-579">
          <div className="bg-brand-offwhite text-slate-800 rounded-2xl overflow-hidden shadow-2xl border-4 border-brand-yellow/50" data-id="element-580">
            <div className="bg-brand-red text-white text-center py-3 font-bold text-sm" data-id="element-581">
              ⚡ PACK PREMIUM COMPLETO: 7 Ebooks Digitales ⚡
            </div>

            <div className="p-8" data-id="element-582">
              {/* Price breakdown */}
              <div className="mb-6" data-id="element-583">
                <div className="flex items-center justify-between mb-4 pb-3 border-b border-slate-200" data-id="element-584">
                  <span className="text-sm font-medium" data-id="element-585">Ebook Principal</span>
                  <span className="font-bold text-brand-navy" data-id="element-586">$9.95</span>
                </div>
                <div className="flex items-center justify-between mb-2" data-id="element-587">
                  <span className="text-sm" data-id="element-588">+ 6 Ebooks de Regalo</span>
                  <span className="font-bold text-brand-green" data-id="element-589">GRATIS</span>
                </div>
                <div className="text-xs text-slate-500 mb-4" data-id="element-590">
                  (Valor: $337.05)
                </div>

                <div className="bg-brand-yellow/20 p-4 rounded-xl border-2 border-brand-yellow/40 mb-6" data-id="element-591">
                  <div className="flex items-center justify-between" data-id="element-592">
                    <span className="font-bold text-brand-navy" data-id="element-593">
                      Precio HOY:
                    </span>
                    <div className="text-right" data-id="element-594">
                      <div className="text-4xl font-bold text-brand-red" data-id="element-595">
                        $9.95
                      </div>
                      <div className="text-sm text-slate-600 font-semibold" data-id="element-596">
                        Ahorras $337.05
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PREMIUM LUXURY CTA BUTTON */}
              <div className="relative group mb-4" style={{
              perspective: '1000px'
            }} data-id="element-597">
                {/* Outer multicolor glow - pulsating */}
                <div className="absolute -inset-1 bg-gradient-to-r from-[#FFD700] via-[#FF6B6B] via-[#4ECDC4] to-[#9D50BB] rounded-2xl blur-lg opacity-60 group-hover:opacity-90 transition duration-500 animate-pulse" data-id="element-598"></div>

                {/* Pulsating gradient border - soft shimmer */}
                <div className="absolute -inset-0.5 bg-gradient-to-r from-[#FFD700] via-[#FF6B6B] via-[#4ECDC4] via-[#9D50BB] to-[#FFD700] rounded-xl opacity-75 group-hover:opacity-100 transition duration-300 animate-[shimmer_2s_ease-in-out_infinite]" data-id="element-599"></div>

                <a href="https://mikioscodigital.com/checkout?variant=51784383398169&quantity=1" className="relative w-full bg-gradient-to-br from-[#FCD34D] to-[#FBBF24] hover:from-[#FBBF24] hover:to-[#F59E0B] rounded-xl transition-all duration-300 overflow-hidden block touch-manipulation" style={{
                transform: 'translateZ(0)',
                boxShadow: '0 10px 30px -5px rgba(251, 191, 36, 0.5), 0 20px 40px -10px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -2px 0 rgba(0, 0, 0, 0.2)'
              }} onMouseEnter={e => {
                if (window.innerWidth >= 768) {
                  e.currentTarget.style.transform = 'translateY(-4px) translateZ(20px) rotateX(2deg)';
                  e.currentTarget.style.boxShadow = '0 20px 50px -5px rgba(251, 191, 36, 0.7), 0 30px 60px -15px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -2px 0 rgba(0, 0, 0, 0.2)';
                }
              }} onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateZ(0)';
                e.currentTarget.style.boxShadow = '0 10px 30px -5px rgba(251, 191, 36, 0.5), 0 20px 40px -10px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -2px 0 rgba(0, 0, 0, 0.2)';
              }} data-id="element-600">
                  {/* Top highlight for 3D effect */}
                  <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/30 to-transparent rounded-t-xl pointer-events-none" data-id="element-601"></div>

                  {/* Bottom shadow for depth */}
                  <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/20 to-transparent rounded-b-xl pointer-events-none" data-id="element-602"></div>

                  {/* Animated shine effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-603"></div>

                  {/* Sparkle particles */}
                  <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-604">
                    <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" data-id="element-605"></div>
                    <div className="absolute top-1/2 right-1/4 w-2 h-2 bg-[#4ECDC4] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                    animationDelay: '0.2s'
                  }} data-id="element-606"></div>
                    <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-[#FF6B6B] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                    animationDelay: '0.4s'
                  }} data-id="element-607"></div>
                    <div className="absolute top-3/4 right-1/3 w-2 h-2 bg-[#9D50BB] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                    animationDelay: '0.6s'
                  }} data-id="element-608"></div>
                  </div>

                  <div className="relative px-4 sm:px-6 md:px-8 py-4 sm:py-5" data-id="element-609">
                    <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-610">
                      <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6 text-[#1e3a8a] group-hover:scale-110 transition-transform duration-300 drop-shadow-[0_2px_8px_rgba(30,58,138,0.4)] flex-shrink-0" strokeWidth={2.5} data-id="element-611" />
                      <span className="text-sm sm:text-base md:text-lg font-bold text-[#1e3a8a] drop-shadow-[0_2px_4px_rgba(30,58,138,0.2)] text-center leading-tight" data-id="element-612">
                        QUIERO MI PACK PREMIUM AHORA
                      </span>
                      <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-[#1e3a8a] group-hover:rotate-12 transition-transform duration-300 drop-shadow-[0_2px_8px_rgba(30,58,138,0.4)] flex-shrink-0" strokeWidth={2.5} data-id="element-613" />
                    </div>
                  </div>

                  {/* Bottom glow */}
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3/4 h-4 bg-gradient-to-r from-transparent via-[#FBBF24] to-transparent blur-xl opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-614"></div>
                </a>
              </div>

              {/* Trust indicators */}
              <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-slate-600 mb-3" data-id="element-615">
                <ShieldCheck className="w-4 h-4 text-brand-green flex-shrink-0" data-id="element-616" />
                <span className="text-center" data-id="element-617">
                  Descarga Inmediata • Garantía 30 días
                </span>
              </div>

              <p className="text-xs sm:text-sm text-brand-red font-bold text-center animate-pulse px-4" data-id="element-618">
                ⏳ Solo las primeras 100 personas
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      <style jsx data-id="element-619">{`
        @keyframes shimmer {
          0%,
          100% {
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
    </section>;
}